<template>
  <div>
    <div class="uk-flex uk-flex-right uk-margin-top">
      <b-button
        name="Создать товарищество"
        color="red"
        @click="$modal.show('new-community-form')"
      />
    </div>
    <WrapperContent>
      <b-table
        ref="tableComponent"
        :header="header"
        :headers="headers"
        :columns="columns"
        :uri="tableUri"
        :rowSize="rowSize"
        :sort="'id'"
      />
    </WrapperContent>
    <CreateNewCommunityForm :isEdit="false" @save="reloadTable"></CreateNewCommunityForm>
  </div>
</template>

<script>
import CreateNewCommunityForm from './_dialogs/community-create-form'

import {mapActions} from 'vuex'

export default {
  name: 'CommunityAdminList',
  components: {CreateNewCommunityForm},
  data: () => ({
    uri: 'community/all/',
    header: '',
    headers: [],
    columns: [],
    rowSize: null
  }),
  computed: {
    tableUri() {
      return this.uri
    }
  },
  methods: {
    ...mapActions({
      getCommunityList: 'community/GET_ALL_COMMUNITY'
    }),
    initTable() {
      this.headers = 'Товарищества'
      this.headers = [
        {name: '#', filter: {type: 'number', field: 'id', operator: ':'}},
        {name: 'Адрес', minWidth: 230},
        {name: 'УНП', filter: {type: 'number', field: 'unp', operator: ':'}},
        {
          name: 'Председатель',
          filter: {type: 'text', field: 'chairmanFullName', operator: ':', position: 'left-top'}
        },
        {name: '', filter: {type: 'clear'}}
      ]
      this.columns = [
        {name: 'id', type: Number},
        {name: 'addressId', type: 'address'},
        {name: 'unp', type: String},
        {name: 'chairmanFullName', type: String},
        {name: 'more', type: 'more'}
      ]
    },
    fetchCommunityList() {
      this.getCommunityList()
    },
    reloadTable() {
      this.$refs.tableComponent.updateData()
    }
  },
  created() {
    this.rowSize = this.$route.params.rowSize
  },
  mounted() {
    this.fetchCommunityList()
    this.initTable()
  }
}
</script>

<style scoped></style>
